/* Atelier - collection page behaviour.

   Two jobs:
     1. The description clamp. Only show the Read more control when the text is actually
        clamped - a two-line description with a "Read more" under it is a broken promise.
     2. Bring the grid in on depth, staggered across the row.

   The depth class is added from here, never from the stylesheet. 36 products hidden by CSS
   that a failed script can never reveal is the worst outcome on this page, so the grid is
   visible by default and only armed once the observer exists to un-hide it. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------- description -- */

  function clamp() {
    var host = document.querySelector('[data-col-desc]');
    if (!host) return;

    var body = host.querySelector('[data-col-desc-body]');
    var btn = host.querySelector('[data-col-desc-toggle]');
    if (!body || !btn) return;

    /* scrollHeight against clientHeight, measured while clamped. A tolerance of 4px keeps
       sub-pixel line heights from showing the control on text that fits. */
    if (body.scrollHeight - body.clientHeight < 4) return;

    btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = host.classList.toggle('is-open');
      btn.textContent = open ? 'Read less' : 'Read more';
    });
  }

  /* -------------------------------------------------------------- grid -- */

  function columns(grid) {
    var cs = window.getComputedStyle(grid);
    var tracks = cs.gridTemplateColumns;
    if (tracks && tracks !== 'none') return tracks.split(' ').filter(Boolean).length;

    /* Dawn's product grid is a flex list at some breakpoints, so fall back to measuring how
       many cards share the first row. */
    var cards = grid.querySelectorAll('.card-wrapper');
    if (!cards.length) return 1;
    var top = cards[0].getBoundingClientRect().top;
    var n = 0;
    for (var i = 0; i < cards.length; i++) {
      if (Math.abs(cards[i].getBoundingClientRect().top - top) > 4) break;
      n++;
    }
    return Math.max(1, n);
  }

  function grid() {
    if (reduced || !('IntersectionObserver' in window)) return;

    var list = document.getElementById('product-grid');
    if (!list) return;

    var cards = [].slice.call(list.querySelectorAll('.card-wrapper > .card'));
    if (!cards.length) return;

    document.documentElement.classList.add('cg-anim');

    var perRow = columns(list);

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting && e.boundingClientRect.bottom > 0) return;
        /* Position in its own row drives the delay, so each row deals itself out left to
           right instead of the whole grid arriving at once. */
        var i = cards.indexOf(e.target);
        var delay = (i < 0 ? 0 : (i % perRow)) * 70;
        window.setTimeout(function () { e.target.classList.add('cg-in'); }, delay);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });

    cards.forEach(function (c) { io.observe(c); });

    /* Anything still hidden after five seconds is shown regardless. Products win over
       choreography. */
    window.setTimeout(function () {
      cards.forEach(function (c) { c.classList.add('cg-in'); });
    }, 5000);
  }

  /* Dawn replaces the whole grid when a filter or sort changes, so the new cards need
     arming too. */
  function watch() {
    var host = document.querySelector('#ProductGridContainer') || document.querySelector('main');
    if (!host) return;

    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = window.setTimeout(function () { pending = null; grid(); }, 200);
    }).observe(host, { childList: true, subtree: true });
  }

  function init() {
    clamp();
    grid();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();